import { FormControl, ValidationErrors } from '@angular/forms';
import { Injectable } from '@angular/core';

enum EValidators {
  REQUIRED = 'required',
  MINLENGHT = 'minlength',
  RANGE = 'range',
  EMAIL = 'email',
  DIGITS = 'digits',
  GTE = 'gte',
  EGN = 'egn',
  CYRILLIC_TEXT = 'invalidCyrillicText'
}

@Injectable({
  providedIn: 'root'
})
export class FormErrorsService {
  constructor() { }

  getErrorMessages(fc: FormControl): string {

    const errors = fc.errors;
    const messages = [];

    if (errors) {
      const keys = Object.keys(errors);

      keys.forEach(errorKey => {
        const message = this.getErrorMessage(errorKey, errors);
        if (message) {
          messages.push(message);
        }
      });
    }

    if (messages.length > 0) {
      return messages[0];
    } else {
      return '';
    }
  }

  private getErrorMessage(errorKey: string, errors: ValidationErrors | '') {
    let message: string;
    const errorMeta = errors[errorKey];

    if (errorMeta) {
      switch (errorKey) {
        case EValidators.REQUIRED: {
          message = 'Това поле е задължително.';
          break;
        }
        case EValidators.MINLENGHT: {
          message = `Полето трябва да е поне ${
            errorMeta.requiredLength
            } символа. Вие сте въвели ${errorMeta.actualLength} символа.`;
          break;
        }
        case EValidators.RANGE: {
          message = `Моля, въведете стойност между ${errorMeta.value[0]} и  ${
            errorMeta.value[1]
            }`;
          break;
        }
        case EValidators.EMAIL: {
          message = 'Моля, въведете валиден имейл адрес.';
          break;
        }
        case EValidators.DIGITS: {
          message = 'Това поле може да съдържа само числа.';
          break;
        }
        case EValidators.GTE: {
          message = `Полето трябва да съдържа стойност по-голяма или равна на ${
            errorMeta.value
            }.`;
          break;
        }
        case EValidators.EGN: {
          message = `Полето трябва да съдържа валиден ЕГН.`;
          break;
        }

        case EValidators.CYRILLIC_TEXT: {
          message = `Полето може да съдържа само кирилица, празно място или тире.`;
          break;
        }
        default: {
          message = `За валидатор ${errorKey} няма добавено съобщение.`;
        }
      }
    }

    return message;
  }
}
